<div class="wrapper">
  <div id="flowRateCalculate" [ngClass]="{'special': (showPlaceholder$ | async)}" #flowRateCalculate></div>
  @if ((showPlaceholder$ | async)) {
    <div class="placeholder">
      <p>Flow rate graph</p>
      <mat-progress-spinner mode="indeterminate" [diameter]="80"></mat-progress-spinner>
    </div>
  }
</div>